<cpw-scan-input
    label="Scan or enter barcode"
    [disabled]="disabled()"
    [barcodeSearchFacade]="equipmentFacade"
    (barcodeScanned)="equipmentBarcodeScanned($event)"></cpw-scan-input>
@if (scanError()) {
    <pf-text type="danger">{{ scanError() }}</pf-text>
}
